// React
import React from 'react'

// Next
import { GetStaticProps } from 'next'

// Components
import Layout from '@/components/website/core/Layout'
import TopicMemes from '@/components/website/TopicMemes'
import CTAComponent from '@/components/website/core/CTA'
import YouMightAlsoLike from '@/components/website/YouMightAlsoLike'
import { DefaultSEO } from '@/components/seo/DefaultSEO'

// Utils
import { getLandingStaticProps } from '@/utils/ui/landing/get-static-props'

// External
import { useTranslation } from 'next-i18next'

const ProductManagerMemes: React.FC = () => {
  const { t } = useTranslation('routes/product-manager-memes')

  return (
    <Layout>
      <DefaultSEO
        title={t('meta.title')}
        description={t('meta.description')}
        url='https://supermeme.ai/memes/product-manager-memes'
      />

      <TopicMemes
        heading={t('hero.heading')}
        description={t('hero.description')}
        imageFolder='static/landing-pages/product-manager-memes'
      />

      <div className='mx-auto max-w-4xl space-y-8 py-12 sm:py-16'>
        <YouMightAlsoLike />

        <CTAComponent />
      </div>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return getLandingStaticProps({
    locale,
    namespaces: ['common', 'routes/product-manager-memes', 'components/cta'],
  })
}

export default ProductManagerMemes
